import { SVGProps } from "react";

const CardHero2DesktopUnderline = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 466 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.0013 15.0015C99.6611 1.55909 367.376 20.6147 456.001 10.5935"
        stroke="#FFA686"
        strokeWidth="20"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CardHero2DesktopUnderline;
